<template>
  <div>
    <el-dialog title="下发指令" :visible.sync="dialogFlag" class="imgbox" width="50%" :before-close="resetForm" :append-to-body="true" :close-on-click-modal="false" >
      <div class="tips" v-if="flag">
        <div><span class="el-icon-info"></span></div>
        <div>
          <span class="">上面topic中含有${tsl.service.identifer}，${tsl.event.identifer}，${identifer}等占位符时，
需要根据物模型进行替换占位符</span>
        </div>
      </div>
      <el-form resetFields label-width="80px" ref="ruleForm"  :rules="rules" :model="form" label-position="top">
        <el-form-item label="Topic" prop="topicClass">
          <el-input :disabled="true" v-model="form.topicClass" autocomplete="off" placeholder="请输入Topic类"></el-input>
        </el-form-item>
        <el-form-item prop="identifer" v-if="flag">
          <span slot="label">标识符</span>
          <el-input v-model="form.identifer" autocomplete="off" placeholder="请输入占位符"></el-input>
        </el-form-item>
        <el-form-item label="消息质量" prop="qos">
          <el-radio-group v-model="form.qos">
            <el-radio :label="0">至多一次</el-radio>
            <el-radio :label="1">至少一次</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="msg">
          <span slot="label">下发数据
            <el-tooltip :content="msgTips" placement="right" effect="light">
              <span class="el-icon-question"></span>
            </el-tooltip>
          </span>
          <el-input v-model="form.msg" autocomplete="off" placeholder="请输入Json格式数据" type="textarea" :rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">下发指令</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { messageIssued } from '@/api/deviceManagement'
var validateMsg = (rule, value, callback) => {
  console.log(value)
  if (value !== '') {
    if (value.indexOf('{') !== -1) {
      try {
        if (JSON.parse(value)) {
          console.log(JSON.parse(value))
          callback()
        } else {
          callback(new Error('请输入正确格式'))
        }
      } catch (err) {
        callback(new Error('请输入正确格式'))
      }
    } else {
      callback(new Error('请输入正确格式'))
    }
  } else {
    callback(new Error('请输入JSON格式数据'))
  }
}
export default {
  props: {
    dialogFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    deviceDetail: { // 必填项
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      flag: false,
      msgTips: '数据格式请见恒大协议',
      form: {
        qos: 0,
        msg: ''
      },
      rules: {
        topicClass: [
          { required: true, message: '请输入Topic', trigger: 'blur' }
        ],
        msg: [
          { required: true, validator: validateMsg, trigger: 'blur' }
          // { required: true, message: '请输入Json格式数据', trigger: 'blur' }
        ],
        qos: [
          { required: true, message: '请选择消息质量', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    console.log(this.rowData, this.deviceDetail)
    this.form.deviceName = this.deviceDetail.deviceName
    this.form.productKey = this.deviceDetail.productKey
    this.form.topicClass = this.rowData.topicClass
  },
  watch: {
    'rowData.topicClass': {
      immediate: true,
      handler (val) {
        val.indexOf('$') > 0 ? this.flag = true : this.flag = false
      }
    }
  },
  methods: {
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.form)
          delete params.topicClass
          // this.rowData.topicClassTemp ? params.topicClassTemp = this.rowData.topicClassTemp : params.topicClassTemp = ''
          params.topicClassTemp = this.rowData.topicClassTemp
          params.msg = JSON.parse(this.form.msg)
          messageIssued(params).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: res.data.message
              })
              this.$refs.ruleForm.resetFields()
              this.dialogFlag = false
              this.$emit('dialog', this.dialogFlag)
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$emit('closeAddDialog')
    }
  }
}
</script>

<style lang='less' scoped>
  .tips{
    padding: 15px;
    display: flex;
    background-color: #e5f3ff;
    margin-bottom: 20px;
    .el-icon-info{
      color: #0070cc;
      margin-right: 10px;
      font-size: 16px;
    }
  }
  /deep/ .el-form-item__label{
    padding: 0;
  }
</style>
